<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />

    <b-row>
      <b-col
        v-for="(campaign, key) in campaigns"
        :key="key"
        cols="12"
        sm="6"
      >
        <iq-card>
          <template v-slot:body>
            <div
              class="d-flex  align-items-center justify-content-between"
            >
              <div
                class="d-flex  justify-content-center  flex-column"
                style="gap:8px;"
              >
                <h4>{{ campaign.campaign_name }} <span class="fontsize-sm"> ({{ campaign.promotion.promotion_name }}) </span> </h4>
                <h5 class=" m-0 ">
                  <span class="text-success"> {{ campaign.campaign_count }} / {{ campaign.target }} </span>  <span class="fontsize-sm"> {{ campaign.campaign_percentage }}</span>
                </h5>
                <p>Channel: {{ campaign.channel }} <br> From: {{ campaign.date_from }} To: {{ campaign.date_to }} </p>
              </div>
              <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-success">
                <i class="ri-inbox-fill" />
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { AgentCampaignTrackerService } from '@/services'

export default {
  name: 'AgentCampaignTracker',

  middleware: ['auth', 'agent'],

  metaInfo () {
    return {
      title: 'Campaign Tracker'
    }
  },

  data () {
    return {
      campaigns: []
    }
  },

  mounted () {
    core.index()
    this.getCampaigns()
  },

  methods: {
    async getCampaigns () {
      await AgentCampaignTrackerService.get().then(({ data }) => {
        this.campaigns = data
      })
    }
  }
}
</script>
